import usePartyVibe from '../../../vibe/usePartyVibe';
import CrowdVibe from './CrowdVibe';
import MyVibeSummary from './MyVibeSummary';
import PartyStarterSuggestions from './PartyStarterSuggestions';
import VibeSelector from './VibeSelector';

export default function PartyVibeExperience({
  eventId,
  userId,
  isHost,
  enabled,
  children,
}) {
  const vibe = usePartyVibe({ eventId, userId, isHost, enabled });
  return children(vibe);
}

export function PartyVibeGate({ vibe }) {
  if (vibe.phase === 'loading') {
    return <p className="text-sm text-white/70">Opening the party…</p>;
  }
  return (
    <VibeSelector
      value={vibe.draft}
      onChange={vibe.updateDraft}
      onSave={vibe.save}
      saveLabel="Save My Vibe"
      saving={vibe.saving}
    />
  );
}

export function PartyCrowdStage({ vibe, isHost, playing, songTitle = '' }) {
  if (!vibe.showCrowd) return null;
  return (
    <CrowdVibe
      crowd={vibe.crowd}
      isHost={isHost}
      playing={playing}
      songTitle={songTitle}
      notice={vibe.notice}
      updating={vibe.updating}
      onUpdate={vibe.updateVibe}
    />
  );
}

export function PartyMyVibePanel({ vibe, eventId, isHost, vibeEnabled }) {
  if (vibe.phase === 'editing') {
    return (
      <section aria-label="My Vibe" className="w-full min-w-0">
        <h3 className="mb-3 text-base font-semibold text-white">My Vibe</h3>
        <VibeSelector
          value={vibe.draft}
          onChange={vibe.updateDraft}
          onSave={vibe.save}
          onCancel={vibe.cancelEdit}
          showCancel
          saveLabel="Update My Vibe"
          saving={vibe.saving}
          compactOptionalPreferences
        />
      </section>
    );
  }
  if (!vibe.saved) return null;
  return (
    <div className="w-full min-w-0">
      <MyVibeSummary
        preference={vibe.saved}
        onEdit={vibe.beginEdit}
      />
      {isHost ? (
        <PartyStarterSuggestions
          eventId={eventId}
          enabled={Boolean(vibeEnabled)}
          vibeSaved={vibe.saved}
        />
      ) : null}
    </div>
  );
}
